/**
 * @module mutype/is-object
 */

//TODO: add st8 tests

//isPlainObject indeed
module.exports = function(o){
	// return obj === Object(obj);
	return !!o && typeof o === 'object' && o.constructor === Object;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/mutype/is-object.js
// module id = MDZY
// module chunks = 0